/**
 * The default implementation for showing an error icon in `TextField` and
 * `TextArea` components that will only display when the error flag is enabled.
 *
 * @remarks \@since 2.5.0
 */
export var defaultGetErrorIcon = function (_message, error, errorIcon) {
    return error && errorIcon;
};
//# sourceMappingURL=getErrorIcon.js.map